(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-premium"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseCarousel = (section) => {
      if (!section || section.dataset.carouselReady === 'true') return;

      const track = section.querySelector('[data-premium-collection-grid]');
      const previous = section.querySelector('[data-collection-previous]');
      const next = section.querySelector('[data-collection-next]');
      if (!track || !previous || !next) return;

      section.dataset.carouselReady = 'true';

      const scrollAmount = () => {
        const card = track.firstElementChild;
        if (!card) return track.clientWidth;
        const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const updateControls = () => {
        const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximumScroll - 2;
      };

      const scrollByCard = (direction) => {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: scrollAmount() * direction, behavior: reduceMotion ? 'auto' : 'smooth' });
      };

      previous.addEventListener('click', () => scrollByCard(-1));
      next.addEventListener('click', () => scrollByCard(1));
      track.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);
      updateControls();
    };

    document.querySelectorAll('[data-premium-collection]').forEach(initialiseCarousel);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-premium-collection]');
      initialiseCarousel(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leavers-design-request"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.leavers-request__form').forEach((form) => {
      if (form.dataset.summaryReady === 'true') return;
      form.dataset.summaryReady = 'true';

      const deliveryDate = form.querySelector('[data-delivery-date]');
      const datePreview = form.querySelector('[data-date-preview]');

      if (deliveryDate && datePreview) {
        const dateFormatter = new Intl.DateTimeFormat('en-GB', {
          day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC'
        });

        const validateDeliveryDate = (normalise = false) => {
          const value = deliveryDate.value.trim();
          const parts = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
          let date = null;
          let valid = value === '';

          if (parts) {
            const day = Number(parts[1]);
            const month = Number(parts[2]);
            const year = Number(parts[3]);
            date = new Date(Date.UTC(year, month - 1, day));
            valid = year >= 1000 && date.getUTCFullYear() === year &&
              date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
          }

          deliveryDate.setCustomValidity(valid ? '' : deliveryDate.dataset.dateError);
          if (valid) {
            deliveryDate.removeAttribute('aria-invalid');
            datePreview.textContent = date ? dateFormatter.format(date) : '';
            if (normalise) {
              deliveryDate.value = parts
                ? parts[1].padStart(2, '0') + '/' + parts[2].padStart(2, '0') + '/' + parts[3]
                : '';
            }
          } else {
            deliveryDate.setAttribute('aria-invalid', 'true');
            datePreview.textContent = normalise ? deliveryDate.dataset.dateError : '';
          }
          return valid;
        };

        deliveryDate.addEventListener('input', () => validateDeliveryDate());
        deliveryDate.addEventListener('change', () => validateDeliveryDate(true));
        deliveryDate.addEventListener('blur', () => validateDeliveryDate(true));
        deliveryDate.addEventListener('invalid', () => validateDeliveryDate(true));
        form.addEventListener('submit', (event) => {
          if (!validateDeliveryDate(true)) {
            event.preventDefault();
            deliveryDate.reportValidity();
          }
        });
        validateDeliveryDate(true);
      }

      const text = (name) => {
        const selected = form.querySelector(`[name="${name}"]:checked`);
        return selected ? selected.value : 'Not selected';
      };

      const selectText = (idSuffix) => {
        const select = form.querySelector(`[id$="${idSuffix}"]`);
        return select && select.value ? select.value : null;
      };

      const productInputs = Array.from(form.querySelectorAll('[name="contact[product]"]'));
      const designInputs = Array.from(form.querySelectorAll('[name="contact[design]"]'));
      const productPanels = Array.from(form.querySelectorAll('[data-product-panel]'));

      const showProduct = (productKey) => {
        productPanels.forEach((panel) => {
          const isActive = panel.dataset.productPanel === productKey;
          panel.hidden = !isActive;
          panel.querySelectorAll('[name="contact[design]"]').forEach((input) => {
            input.disabled = !isActive;
          });
        });
      };

      const selectFirstDesign = (productKey) => {
        const activePanel = productPanels.find((panel) => panel.dataset.productPanel === productKey);
        const firstDesign = activePanel ? activePanel.querySelector('[name="contact[design]"]:not(:disabled)') : null;
        if (firstDesign) firstDesign.checked = true;
      };

      const update = () => {
        const product = form.querySelector('[data-summary-product]');
        const design = form.querySelector('[data-summary-design]');
        const colours = form.querySelector('[data-summary-colours]');
        const back = form.querySelector('[data-summary-back]');
        const order = form.querySelector('[data-summary-order]');
        if (!product || !design || !colours || !back || !order) return;

        product.textContent = text('contact[product]');
        design.textContent = text('contact[design]');
        back.textContent = text('contact[back_print]');
        order.textContent = text('contact[ordering_route]');

        const selectedColours = ['-main-colour', '-second-colour', '-accent-colour']
          .map(selectText)
          .filter(Boolean);
        colours.textContent = selectedColours.length ? selectedColours.join(' / ') : 'Not selected';
      };

      productInputs.forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked) return;
          designInputs.forEach((designInput) => { designInput.checked = false; });
          showProduct(input.dataset.productKey);
          selectFirstDesign(input.dataset.productKey);
          update();
        });
      });

      form.addEventListener('change', update);
      const selectedProduct = productInputs.find((input) => input.checked);
      if (selectedProduct) showProduct(selectedProduct.dataset.productKey);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
